import { Theme, makeStyles } from '@material-ui/core'

export const useAddProductFormStyles = makeStyles((theme: Theme) => ({
    addProductContainer: {
        padding: theme.spacing(1.87, 0),
        marginTop: theme.spacing(1.5),
        marginLeft: theme.spacing(0.5),
        maxWidth: '98%',
    },
    rowContainer: {
        backgroundColor: theme.palette.secondary.light,
        padding: theme.spacing(1.87, 0),
    },
    smallContainer: {
        maxWidth: 423,
        marginRight: theme.spacing(8),
    },
    inputField: {
        '& .MuiOutlinedInput-input': {
            padding: theme.spacing(1.75),
        },
        '& label': {
            transform: `translate(${theme.spacing(1.75)}px, ${theme.spacing(
                2
            )}px) scale(1)`,
        },
    },
}))
